export const inspectTable = [
  {
    content: '1. 안전보건관리책임자 업무수행에 필요한 권한과 예산을 부여받고 적합한 용도로 집행',
    tail: '<span style="font-weight: normal">안전보건관리 체제(조직도) 수립 여부</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    title: '<span style="font-weight: normal">종사자 안전보건 확보를 위한 예산편성 여부 (예시: 석면제거 등)</span>',
    titleColor: '#ffffff',
    content: '2. 서울특별시교육청의 산재예방계획 수립',
    tail: '<span style="font-weight: normal">산업안전보건·중대재해예방 기본계획 수립 여부</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '3. 안전보건관리규정의 작성 및 변경',
    tail: '<span style="font-weight: normal">서울특별시교육청 안전보건관리규정 제정 여부</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '4. 근로자 안전보건교육 실시',
    tail: '<span style="font-weight: normal">근로자 정기교육 결과 보고</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '5. 작업환경의 점검 및 개선',
    tail: '<span style="font-weight: normal">작업환경측정 실시계획 및 결과<br/>※ 작업환경측정 대상 유해인자에 노출되는 근로자가 있는 작업장이 없을 시 양호로 평가</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '6. 근로자의 건강진단 등 건강관리',
    tail: '<span style="font-weight: normal">일반건강검진 수검확인서 등</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '7. 산업재해 원인조사 및 재발 방지대책 수립',
    tail: '<span style="font-weight: normal">산업재해 원인조사 및 재발방지대책 계획, 안내 공문 등<br/>※ 산업재해 미발생 시 양호로 평가</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '8. 산업재해에 관한 통계의 기록 및 유지관리',
    tail: '<span style="font-weight: normal">산업재해 통계 보고 등</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '9. 안전장치 및 보호구 구입 시 적격품 여부 확인',
    tail: '<span style="font-weight: normal">안전인증(KCs) 품질확인서, 안전보호구 지급대장 등</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '10. 위험성평가의 실시',
    tail: '<span style="font-weight: normal">위험성 평가 실시계획 및 결과 보고 등</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
  {
    content: '11. 안전보건규칙에서 정하는 근로자의 위험 또는 건강장해의 방지',
    tail: '<span style="font-weight: normal">직종별 안전·보건 자체점검표 등</span>',
    tailColor: '#ffffff',
    isChecked: '',
  },
];
